'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SPEED_CURVE = exports.SPEED_CURVE = 'speedCurve';
var PREVIEW = exports.PREVIEW = 'preview';
var STANDARD = exports.STANDARD = 'STANDARD';